module.exports = __webpack_public_path__ + "static/media/heart.5c2404fc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/heart.svg
// module id = 28
// module chunks = 0